export { default } from './AutoSelectionLanding';
